import { size } from '@styles/theme'
import styled from '@emotion/styled'
import { format } from 'date-fns'

import { ButtonBase, } from '@mui/material'
import PostNumber from '../PostNumber'
import Heart from '../Heart'
import {
  PiArrowsClockwiseBold,
  PiChatCircleBold,
  PiLinkBold,
} from 'react-icons/pi'

const TopBarClearfix = styled.div`
  height: ${size(7)};
  width: 100%;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: 100vw;
  padding: ${size(1.5)};
  // padding-top: 0;
  border-bottom: 0.5px solid rgba(47, 51, 54);
  font-size: 15px;
  line-height: 20px;
`


const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${size(2)} 0;
`

const ActionLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 60%;
`

const Action = styled.div`
  display: flex;
  align-items: center;
  color: grey;
`
const ActionText = styled.span`
  padding-right: ${size(2)};
  letter-spacing: 0.75px;
  display: flex;
  align-items: center;
`
  
const ActionNumber = styled.span`
  color: white;
  font-weight: bold;
`

const Image = styled.img`
  width: 100%;
  max-height: ${size(45)};
  object-fit: cover;
  border-radius: 15px;
  opacity: 0;
`


const PostActionBarFullScreen = ({ post, clickHandlers, stats }) => {
  const { handleReplyClick, handleLikeClick, handleRepostClick, handleShareClick } = clickHandlers || {}
  const { likeCount, replyCount, repostCount, currentUserLiked } = stats || {}

  return (
    <Container>
      <ActionsContainer style={{ borderBottom: '0.5px solid rgba(47, 51, 54)', paddingTop: size(1), paddingBottom: size(1.5) }}>
        <ActionLeft>
          <Action>
            <ActionText>
              {post?.createdAt && format(new Date(post.createdAt), 'HH:MM')}
              <div style={{ backgroundColor: 'grey', height: '0.15rem', width: '0.15rem', borderRadius: '100%', margin: `0 ${size(0.75)} 0 ${size(0.5)}` }} />
              {post?.createdAt && format(new Date(post.createdAt), 'MMM d, yyyy')}
            </ActionText>
          </Action>
        </ActionLeft>
      </ActionsContainer>
      <ActionsContainer style={{ borderBottom: '0.5px solid rgba(47, 51, 54)', padding: `${size(1.75)} 0` }}>
        <ActionLeft>
          <Action>
            <ActionText>
              <ActionNumber>
                <PostNumber
                  value={replyCount}
                  showZero
                />
              </ActionNumber>
              &nbsp;Replies
            </ActionText>
          </Action>
          <Action>
            <ActionText>
              <ActionNumber>
                <PostNumber
                  value={repostCount}
                  showZero
                />
              </ActionNumber>
              &nbsp;Reposts
            </ActionText>
          </Action>
          <Action>
            <ActionText>
              <ActionNumber>
                <PostNumber
                  value={likeCount}
                  showZero
                />
              </ActionNumber>
              &nbsp;Likes
            </ActionText>
          </Action>
        </ActionLeft>
      </ActionsContainer>
      <ActionsContainer style={{ paddingBottom: size(0.5) }}>
        <ActionLeft style={{ justifyContent: 'flex-start', gap: size(8) }}>
          <Action onClick={handleReplyClick}>
            <PiChatCircleBold fill='grey' size={size(2.75)} />
          </Action>
          <Action onClick={handleRepostClick}>
            <PiArrowsClockwiseBold fill='grey' size={size(2.75)} style={{ transform: 'rotate(90deg)' }} />
          </Action>
          <Action onClick={handleLikeClick}>
            <Heart
              currentUserLiked={currentUserLiked}
              likeCount={likeCount}
              heartSize={2.75}
            />
          </Action>
        </ActionLeft>
        <ButtonBase onClick={handleShareClick}>
          <PiLinkBold fill='grey' size={size(2.75)} />
        </ButtonBase>
      </ActionsContainer>
    </Container>
  )
}

export { PostActionBarFullScreen }
